import { render, staticRenderFns } from "./InventoryItemForm.vue?vue&type=template&id=b0de7b32&"
import script from "./InventoryItemForm.vue?vue&type=script&lang=ts&"
export * from "./InventoryItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports